import { render, staticRenderFns } from "./EncountersReview.vue?vue&type=template&id=2cc62fe0&"
import script from "./EncountersReview.vue?vue&type=script&lang=js&"
export * from "./EncountersReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports